import { useState } from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import MenuBookRounded from "@mui/icons-material/MenuBookRounded";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import FlowActions from "components/FlowActions";
import PublishSteps from "./components/PublishSteps";
import "./publish.css";

export default function PublishHere({ user }) {
  const [started, setStarted] = useState(false);
  return (
    <DashboardLayout>
      {started ? (
        <PublishSteps user={user} />
      ) : (
        <Box className="publish-workspace" sx={{ maxWidth: 1100, mx: "auto", py: 4 }}>
          <Typography variant="overline" sx={{ color: "#147d48", letterSpacing: 1.5 }}>
            SUA PRÓXIMA OBRA
          </Typography>
          <Typography variant="h3" sx={{ color: "#182d27", letterSpacing: -1, my: 1 }}>
            Vamos publicar seu livro
          </Typography>
          <Typography variant="body2" sx={{ color: "#64766e", mb: 4 }}>
            Envie seus arquivos, revise as informações e acompanhe cada etapa até a publicação.
          </Typography>
          <Card
            sx={{
              border: "1px solid #e1e9e4",
              borderRadius: 3,
              p: { xs: 3, md: 5 },
              boxShadow: "none",
            }}
          >
            <MenuBookRounded sx={{ fontSize: 48, color: "#147d48", mb: 3 }} />
            <Typography variant="h5" mb={3}>
              Tudo pronto para começar?
            </Typography>
            <Stack spacing={3}>
              {[
                [
                  "1",
                  "Miolo do livro",
                  "Tenha o conteúdo em PDF. Vamos identificar as dimensões e o número de páginas.",
                ],
                [
                  "2",
                  "Capa e acabamento",
                  "Confira o papel e as medidas, envie a capa e revise o encaixe da arte.",
                ],
                [
                  "3",
                  "Informações e publicação",
                  "Preencha os dados da obra, confira as informações e publique.",
                ],
              ].map(([number, title, description]) => (
                <Stack key={number} direction="row" spacing={2}>
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      flexShrink: 0,
                      display: "grid",
                      placeItems: "center",
                      bgcolor: "#e9f5ed",
                      borderRadius: 2,
                      color: "#147d48",
                      fontWeight: 700,
                    }}
                  >
                    {number}
                  </Box>
                  <Box>
                    <Typography variant="subtitle2">{title}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {description}
                    </Typography>
                  </Box>
                </Stack>
              ))}
            </Stack>
          </Card>
          <FlowActions
            onContinue={() => setStarted(true)}
            continueLabel="Iniciar publicação"
            hint="Comece pelo PDF do miolo. A capa será solicitada na próxima etapa."
          />
        </Box>
      )}
    </DashboardLayout>
  );
}
